import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import scroll from './scroll/scroll.js'

export default contract({
  scroll: array([
    scroll
  ]),
})
